import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ENV } from '../../../environment';
import { Credentials } from '../../../shared/models/credentials';
import { ToastService } from '../../../shared/services/toastr.service';
import { RedirectService } from '../../../shared/services/redirect.service';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { SignupState } from '../../signup_state';
import { LogService } from '../../../shared/services/log.service';
import { UserService } from '../../../shared/services/user.service';
import { updatePassword } from './state/passwords_form_actions_creator';
import { DEFAULT_B2B_LOGIN_PAGE } from '../constants';
import { take } from 'rxjs/operators';
import { AnalyticsTrackingProvider, AuthService } from '@yotpo-ui/core';
import { StorageService } from '../../../install/shared/services/storage.service';
import { STORAGE } from '../../../install/shared/navigation/constants';

@Component({})
export abstract class PasswordUpdaterBaseComponent {

  protected eventName;

  constructor(protected toastr: ToastService,
              protected redirectService: RedirectService,
              protected translateService: TranslateService,
              protected route: ActivatedRoute,
              protected authService: AuthService,
              protected logger: LogService,
              protected store: Store<SignupState>,
              protected userService: UserService,
              protected redCrossService: AnalyticsTrackingProvider,
              protected storageService: StorageService
  ) {}

  updatePassword(password, confirmPassword): void {
    let resetToken = this.route.snapshot.queryParams['reset_password_token'];
    this.userService.updatePassword(resetToken, password, confirmPassword).pipe(take(1)).subscribe((updatedUser) => {
      this.userService.emailPasswordLogin(updatedUser.email, password).pipe(take(1)).subscribe((utoken) => {
        this.setUserCredentials(this.route.snapshot.queryParams['app_key'], utoken);
        this.redCrossService.track(this.eventName,
          {
            ctaType: 'Button',
            ctaText: this.eventName
          });
        this.redirectToB2B();
      }, (error) => {
        this.errorProcessingRequest(password, error);
      });
    }, (error) => {
      this.errorProcessingRequest(password, error);
    });
  }

  private errorProcessingRequest(password, error) {
    let payload;
    if (error.type === 'Exceptions::WeakPassword') {
      payload = {
        value: password,
        error: {
          show: true,
          message: this.translateService.instant('SIGNUP.CHANGE_PASSWORD.VALIDATION_ERRORS.WEAK_PASSWORD')
        }
      };
    }

    let errMsg = error.message ? error.message : error.toString();
    if (errMsg.includes('SsoSamlAuth')) {
      this.redirectToNewB2BLogin();
      return;
    }

    payload = payload || { error: true };
    this.store.dispatch(updatePassword({password: payload}));
    this.toastr.error('signup', 'errorProcessingRequest', this.translateService.instant('SIGNUP.CHANGE_PASSWORD.VALIDATION_ERRORS.PROCESSING_ERROR'), error);
    this.logger.log(error);
  }

  private redirectToNewB2BLogin() {
    this.redirectService.redirectTo(ENV.YotpoNewB2bEndpoint + DEFAULT_B2B_LOGIN_PAGE);
  }

  private redirectToB2B() {
    this.redirectService.redirectTo(ENV.YotpoNewB2bEndpoint + '#/?app_key=' +
      this.route.snapshot.queryParams['app_key'] + '&utoken=' + this.authService.getCredentials().utoken);
  }

  private setUserCredentials(app_key, utoken) {
    let creds = new Credentials(app_key, utoken);
    this.authService.setCredentials(creds);
    this.storageService.set(STORAGE.APP_KEY, creds.appKey);
    this.storageService.set(STORAGE.UTOKEN, creds.utoken);
  }
}
